<template lang="html">
  <div class="my-correction-task">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="firstLabel" name="first">
        <ToBeCorrected @getAllTobeCorrectedTotal="getAllTobeCorrectedTotal" @getAllCorrectedTotal="getAllCorrectedTotal" />
      </el-tab-pane>
      <el-tab-pane :label="secondLabel" name="second">
        <Corrected @getAllTobeCorrectedTotal="getAllTobeCorrectedTotal" @getAllCorrectedTotal="getAllCorrectedTotal" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ToBeCorrected from './components/tobeCorrected'
import Corrected from './components/corrected'
export default {
  data() {
    return {
      activeName: 'first',
      allTobeCorrectedTotal: 0,
      allCorrectedTotal: 0
    }
  },
  components: {
    ToBeCorrected,
    Corrected
  },
  computed: {
    firstLabel () {
      return `待批改(${this.allTobeCorrectedTotal})`
    },
    secondLabel () {
      return `已批改(${this.allCorrectedTotal})`
    }
  },
  created () {
    // this.$store.commit('setIfShowBreadcrumb', true)
  },
  mounted () {
    // $('.my-correction-task').parent().css({padding: 0})
  },
  beforeDestroy () {
    // this.$store.commit('setIfShowBreadcrumb', false)
    // $('.el-main').css({padding: '20px'})
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    getAllTobeCorrectedTotal (val) {
      this.allTobeCorrectedTotal = val
    },
    getAllCorrectedTotal (val) {
      this.allCorrectedTotal = val
    }
  }
}
</script>

<style lang="less">
.my-correction-task{
  .el-tabs{
    .el-tabs__header{
      background: #fff!important;
      padding: 10px 20px 0 20px;
      .el-tabs__nav-wrap::after{
        background: transparent;
      }
    }
    // .el-tabs__content{
    //   .toBeCorrectedWrapper{
    //     background: #fff;
    //   }
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my-correction-task/index.vue